const en = {
  giga_more_info: 'More Info',
  giga_pay_next_plan: 'Pay your Next+',
  giga_pay_fiber_tv: 'Pay your Fibre & TV',
  giga_go_to_payment: 'Go to payment',
  giga_link_ebill: 'https://ebill.vodafone.al/',
  giga_link_abcom: 'https://portal.abcom.al/',
  giga_location_permission: 'We need permission to access your location.',
  giga_open_settings: 'Open settings',
  giga_bonus_helper_text: 'Please type your Name and Surname as by Fix contract and share your location. We will use your data to check internet fix quality in your area.',
  giga_bonus_section_title: 'My Details',
  giga_bonus_section_data_title: 'Name and Location',
  giga_bonus_label_name: 'Name',
  giga_bonus_helper_text_name: 'Please write your name and surname correctly',
  giga_bonus_use_my_location: 'Use my current location',

  giga_bonus_send: 'Send',

  giga_bonus_success: 'Congratulations!',
  giga_bonus_success_message: 'You benefitted 100GB valid for 24 hours, to be used as a hotspot from all members.\n\nThank you for being part of Vodafone!',
  giga_bonus_error_410: 'Ups, You are not a GigaFamily / GigaBusiness!',
  giga_bonus_error_message_410: 'You have to be part of GigaFamily / GigaBusiness to profit the bonus.',
  giga_bonus_error_411: 'Congratulations!',
  giga_bonus_error_message_411: 'You or one of group members has profited the bonus.\n\nThis bonus can be profited only once in 24.',
  giga_bonus_error_412: 'There is not any technical issue!',
  giga_bonus_error_message_412: 'There is not any technical issue reported in your area. Please make sure your modem is connected.\n\nYour area will be checked, within 30 minutes. If you still have problems, please raise the request again.',
  giga_bonus_error: 'Something went wrong!',
  giga_bonus_error_message: 'Please make sure your modem is connected.\n\nYour area will be checked, within 30 minutes. If you still have problems, please raise the request again.',
  giga_bonus_get_help: 'Help',
  giga_bonus_go_back: 'Go back',
  giga_bonus_help_url: 'https://www.vodafone.al/en/suport/',

  giga_bonus_details_title: 'Bonus Details',
  giga_bonus_details_section_1: 'We guarantee uninterrupted service meanwhile we give solutions to technical issues.\n',
  giga_bonus_details_section_2: '100 GB Bonus from Vodafone to be always connected.\n',
  giga_bonus_details_item_1: 'Only one of Giga Family / GigaBusiness members can profit the bonus.',
  giga_bonus_details_item_2: 'The bonus is exclusive only in My Vodafone App.',
  giga_bonus_details_item_3: 'You can profit the bonus only once in 24 hours.',
  giga_bonus_details_item_4: 'It is valid for 24 hours.',
  giga_bonus_details_item_5: 'It has priority over other internet offers.',

  giga_bonus_error_permission_denied: '! We cannot use your location. Please make sure Location is ON in your mobile settings',
  giga_bonus_error_position_unavailable: '! We cannot use your location. Please make sure Location is on in your mobile settings',
  giga_bonus_error_location_timeout: '! We cannot find your location. Can you please move from there and try again',
}

export default en
